import axios from 'axios'
import { HttpFunctions } from '@/api/http-functions'

const HTTPInit = axios.create({
  baseURL: process.env.API_URL
})

HTTPInit.defaults.headers.common['Authorization'] = HttpFunctions.getToken()
HTTPInit.defaults.headers.post['Content-Type'] = 'application/json'

HTTPInit.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    window.location = process.env.LOGIN_URL
  } else {
    return Promise.reject(error)
  }
})

export const HTTP = HTTPInit



// WEBPACK FOOTER //
// ./src/api/http-common.js